{
  "name": "pmc-frontend",
  "version": "0.49.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "react-router build",
    "dev": "react-router dev",
    "start": "node ./build/server/index.js",
    "typecheck": "react-router typegen && tsc",
    "lint": "eslint .",
    "lint:ci": "eslint . --max-warnings=12",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:ci": "vitest run",
    "test:cov": "vitest run --coverage",
    "test:cov:full": "vitest run --coverage --config vitest.cov-full.config.ts",
    "sanity:typegen": "npx --yes sanity@latest typegen generate",
    "api:gen": "openapi-typescript ../backend/openapi.json -o app/types/generated/api.ts",
    "prepare": "cd .. && husky .husky || exit 0"
  },
  "lint-staged": {
    "app/**/*.{ts,tsx}": "eslint --fix"
  },
  "dependencies": {
    "@clerk/react": "6.18.3",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@fontsource/inter": "^5.3.0",
    "@intercom/messenger-js-sdk": "^0.0.20",
    "@microsoft/clarity": "^1.0.2",
    "@mui/icons-material": "^9.5.0",
    "@mui/material": "^9.5.0",
    "@mui/x-charts": "^9.16.0",
    "@mui/x-data-grid": "^9.16.0",
    "@mui/x-data-grid-pro": "^9.16.0",
    "@portabletext/react": "^8.0.1",
    "@react-router/node": "~8.5.1",
    "@reduxjs/toolkit": "^2.13.0",
    "@sanity/client": "^8.14.1",
    "@sentry/react": "^11.10.0",
    "@sentry/vite-plugin": "^11.10.0",
    "clsx": "^2.1.1",
    "embla-carousel-autoplay": "^8.6.0",
    "embla-carousel-react": "^8.6.0",
    "fflate": "^0.8.3",
    "formik": "^2.4.9",
    "groq": "^6.21.0",
    "hono": "^4.13.14",
    "isbot": "^5.2.2",
    "react": "^19.3.1",
    "react-dom": "^19.3.1",
    "react-ga4": "^3.0.1",
    "react-google-recaptcha-v3": "^1.11.0",
    "react-number-format": "^5.4.5",
    "react-redux": "^9.3.1",
    "react-router": "~8.5.1",
    "react-router-hono-server": "^4.1.7",
    "react-toastify": "^11.2.0",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@eslint/css": "^2.0.1",
    "@eslint/js": "^9.39.5",
    "@react-router/dev": "~8.5.1",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/react": "^16.3.3",
    "@types/node": "^24.19.2",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitest/coverage-v8": "^5.0.5",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-simple-import-sort": "^14.0.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.13.0",
    "husky": "^9.1.7",
    "jiti": "^2.7.0",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "openapi-typescript": "^7.13.0",
    "prettier": "3.9.10",
    "sass": "^1.107.0",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.72.1",
    "vite": "^8.3.5",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^5.0.5"
  },
  "overrides": {
    "js-yaml": "4.3.2",
    "@hono/node-server": "^2.1.5"
  }
}
